import { setBearerTokenForAllRequests } from "@/services/axios";
import Keycloak, { KeycloakConfig } from "keycloak-js";
import { useAuthStore } from "@/pinia/useAuthStore";

const setBaseURLforLocalBuild =
  location.origin !== "http://localhost:4200"
    ? `${location.origin}/auth`
    : import.meta.env.VITE_APP_KEYCLOAK_URL;

const keycloakUrl =
  import.meta.env.MODE == "development"
    ? import.meta.env.VITE_APP_KEYCLOAK_URL
    : setBaseURLforLocalBuild;
const keycloakRealm = import.meta.env.VITE_APP_KEYCLOAK_REALM ?? "oventus";
const keycloakClientId = localStorage.getItem("clientId") ?? "oventus-connect";

const onLoad = "login-required";

const initOptions: KeycloakConfig = {
  url: keycloakUrl,
  realm: keycloakRealm,
  clientId: keycloakClientId,
};
export class KeycloakAuthService {
  private readonly keycloak: any = new Keycloak(initOptions);

  public init(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.keycloak
        .init({ onLoad: onLoad, checkLoginIframe: false })
        .then(async (auth: any) => {
          if (!auth) {
            location.reload();
          }

          this.setTokenRefresh();

          // https://stackoverflow.com/a/52386934/12175838

          resolve(this.keycloak);
        })
        .catch(() => {
          this.logout();
          reject(new Error("Authentication failed"));
        });
    });
  }

  public logout(): void {
    localStorage.removeItem("tab");
    localStorage.removeItem("subTab");
    localStorage.removeItem("diaryDate");
    localStorage.removeItem("contactsTab");
    localStorage.removeItem("divertTab");
    localStorage.removeItem("settingTab");
    localStorage.removeItem("messageSelectDestination");
    localStorage.setItem("fresh-login", "true");
    this.keycloak.logout();
  }

  private setTokenRefresh(): void {
    console.log("EXPIRES_IN", this.calculateExpireTime());
    //Token Refresh
    setInterval(() => {
      this.updateToken(70);
    }, 60000); // 1 minutes interval
  }

  public updateToken(validaity: number) {
    this.keycloak
      .updateToken(validaity)
      .then(async (refreshed: any) => {
        if (refreshed) {
          const payloadRefreshedTokens = {
            idToken: this.keycloak.idToken,
            accessToken: this.keycloak.token,
          };
          await this.commitAccessTokenToStore(payloadRefreshedTokens);
        } else {
          console.log(
            "Token not refreshed, valid for " +
              this.calculateExpireTime() +
              " seconds",
          );
        }
      })
      .catch(() => {
        console.log("Failed to refresh token");
      });
  }

  private calculateExpireTime() {
    return Math.round(
      this.keycloak.tokenParsed.exp +
        this.keycloak.timeSkew -
        new Date().getTime() / 1000,
    );
  }

  private async commitAccessTokenToStore(payload: any): Promise<void> {
    const { loginApp, resetAuthState } = useAuthStore();
    if (
      payload.accessToken &&
      payload.idToken &&
      payload.accessToken != "" &&
      payload.idToken != ""
    ) {
      loginApp(payload);
      setBearerTokenForAllRequests(payload.accessToken);
    } else {
      resetAuthState();
    }
  }
}
export const keycloakAuthService = new KeycloakAuthService();
